import { MyEmergencyPlanFormSchema } from '@/features/my-emergency-plan/presentation/utils/types';

export const ref16TrueValues: Array<MyEmergencyPlanFormSchema['ref15'][number]> = [
  'babies-children-young-people',
  'people-who-need-assistance',
  'pets',
  'livestock-and-other-animals',
];
